<template>
  <sui-page>
    <sui-page-header
      :pageId="this.$options.name"
    />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <cmp-site-select
              ref="selectSIT"
              :pageId="this.$options.name"
              :selected="frame0.selectData.SIT"
              :defaultOption="'select'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WORK_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-7">
            <cmp-task-id-select
              ref="taskIdSelect"
              :pageId="this.$options.name"
              :default1LevelOption="'all'"
              :default2LevelOption="'all'"
              :default3LevelOption="'all'"
              @select-changed="onChangeBizCodes"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PLANT_CD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame0.plantCdText"
              maxlength="100"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PLANT_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame0.plantNmText"
              maxlength="100"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="comboUseYn"
              :selected="frame0.selectData.COD_DTSVC_USE_YN"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="'PGE_CMY_00019'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid0"
        :columns="gridColumns"
        :dataset="'dataset0'"
        :enabletooltips="true"
        :showDisplayCountControl="false"
        :initialPagesize="10"
      >
        <div class="btn_wrapR">
          <sui-button
            v-permission:download="'PGE_CMY_00019'"
            type="button"
            class="comm_btn_gridTop  comm_ico_excel"
            @click="onDownloadExcel"
          >
            {{ $t("MSG_BTN_EXCEL_DOWN") }}
          </sui-button>
        </div>
      </sui-grid>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['firstRegistrationDTM', 'finalModificationDTM'];
const gridEditor = utils.getGridCellFactory();

export default {
  name: 'PGE_CMY_00019', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      pageName: 'PGE_CMY_00019',
      codes: CommonConstants.selectOptions(),
      frame0: {
        selectData: {
          // Codes
          SIT: {
            key: '',
            label: '',
          },
          COD_TASK_1: {
            label: '',
            key: '',
          },
          COD_DTSVC_USE_YN: {
            label: '',
            key: '',
          },
          plantCdText: '',
          plantNmText: '',
        },
      },
      localdata0: [],
      gridColumns: [{
        text: 'No.',
        datafield: 'dataset-row-id',
        hidden: true,
      }, {
        text: this.$t('MSG_TXT_SITE_ID'),
        datafield: 'siteId',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SITE_ABBR'),
        datafield: 'siteAbbName',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_SITE_ABBR_EN'),
        datafield: 'siteEnAbbName',
        width: 250,
      }, {
        text: this.$t('MSG_TXT_WORK_NM'),
        datafield: 'taskName',
      }, {
        text: this.$t('MSG_TXT_PLANT_CD'),
        datafield: 'plantCode',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_PLANT_NM'),
        datafield: 'plantName',
        width: 300,
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'siteInfoUseYnName',
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'userName',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          gridEditor.createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
          }, this.dataset0, this.$refs.grid0);
        },
        initwidget(row, column, value, htmlElement) {
          gridEditor.refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '150px',
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'dataset-row-id',
      type: 'string',
      map: 'dataset-row-id',
    }, {
      name: 'siteId',
      type: 'string',
      map: 'siteId',
    }, {
      name: 'siteAbbName',
      type: 'string',
      map: 'siteAbbName',
    }, {
      name: 'siteEnAbbName',
      type: 'string',
      map: 'siteEnAbbName',
    }, {
      name: 'taskName',
      type: 'string',
      map: 'taskName',
    }, {
      name: 'plantCode',
      type: 'string',
      map: 'plantCode',
    }, {
      name: 'plantName',
      type: 'string',
      map: 'plantName',
    }, {
      name: 'siteInfoUseYnName',
      type: 'string',
      map: 'siteInfoUseYnName',
    }, {
      name: 'finalModificationUserId',
      type: 'string',
      map: 'finalModificationUserId',
    }, {
      name: 'finalModificationDTM',
      type: 'string',
      map: 'finalModificationDTM',
    }, {
      name: 'displayLanguageId',
      type: 'string',
      map: 'displayLanguageId',
    }, {
      name: 'knoxId',
      type: 'string',
      map: 'knoxId',
    }, {
      name: 'userName',
      type: 'string',
      map: 'userName',
    }, {
      name: 'userGlobalName',
      type: 'string',
      map: 'userGlobalName',
    }, {
      name: 'departmentName',
      type: 'string',
      map: 'departmentName',
    }, {
      name: 'departmentEnglishName',
      type: 'string',
      map: 'departmentEnglishName',
    }],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onSearchClick() {
      const selectedLevel1Code = this.$refs.taskIdSelect.getSelected1LevelTask().key;
      const selectedLevel2Code = this.$refs.taskIdSelect.getSelected2LevelTask().key;
      const selectedLevel3Code = this.$refs.taskIdSelect.getSelected3LevelTask().key;

      // eslint-disable-next-line no-nested-ternary
      let searchTaskCode = (this.selectedBizCode.length < 2 ? ''
        : this.$refs.taskIdSelect.getSelected3LevelTask().key === 'ALL' ? ''
          : utils.trim(this.$refs.taskIdSelect.getSelected3LevelTask().key));

      if (selectedLevel1Code !== 'ALL' && selectedLevel2Code === 'ALL' && selectedLevel3Code === 'ALL') {
        searchTaskCode = selectedLevel1Code.substr(0, 6);
      } else if (selectedLevel1Code !== 'ALL' && selectedLevel2Code !== 'ALL' && selectedLevel3Code === 'ALL') {
        searchTaskCode = selectedLevel2Code.substr(0, 9);
      }

      if (selectedLevel3Code !== 'ALL') {
        searchTaskCode = selectedLevel3Code;
      }

      const codeValue = this.frame0.selectData;
      const queryParams = {
        searchSiteCode: utils.trim(codeValue.SIT.key) || '',
        searchModuleCode: utils.trim(codeValue.COD_TASK_1.key) || '',
        searchUseYn: utils.trim(codeValue.COD_DTSVC_USE_YN.key) || '',
        searchPlantCode: utils.trim(this.frame0.plantCdText) || '',
        searchPlantName: utils.trim(this.frame0.plantNmText) || '',
        searchTaskCode: searchTaskCode || '',
      };

      if (queryParams.searchSiteCode === '') {
        utils.messageBox('warning', this.$t('MSG_ALT_IS_SRCH_SELT_SITE'));
        return;
      }

      http.request(this.$options.name, 'DTS_CMY_00013', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);

        this.localdata0 = res.data;
        this.dataset0.setRawData(this.localdata0);
      }).catch(error => {
        console.log(error);
      });
    },
    onResetClick() {
      this.$refs.selectSIT.reset();
      this.$refs.comboUseYn.reset();
      this.$refs.taskIdSelect.reset();
      this.frame0.plantCdText = '';
      this.frame0.plantNmText = '';
    },
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onDownloadExcel() {
      const metaObj = {
        // "headerTitle" : {
        //   "codeName" : this.$t('MSG_TXT_CODE_NAME'),
        //   "codeEngName" : this.$t('MSG_TXT_CODE_ENAME'),
        //   "codeAbb" : this.$t('MSG_TXT_ABBR'),
        // },
        headerFontSize: 16,
        headerFontColor: 1,
        headerForegroundColor: 22,
      };

      const sPageId = this.$options.name;
      const objGridColumns = this.gridColumns;
      const objGridDataset = this.dataset0;
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `plant-list_${sToday}.xlsx`;

      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, metaObj);
    },
  },
};
</script>
<style scoped>
</style>
